import { listSearchSchema } from '@/shared/patterns/list-search';

import { creditNoteDeletedFilters } from './credit-note-deleted.filters';

/** `validateSearch` de `/ccb/excluidos` (U07): página, tamanho e os filtros legíveis. Leve, para a rota. */
export const creditNoteDeletedSearch = listSearchSchema({ ...creditNoteDeletedFilters.shape });
